import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { db } from '../../../utils/firebase-config';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import updateUserProgress from '../userProgressTrack/updateUserProgress';

const SummaryTable = ({ userId, totalIncomeMonthly, collectionName }) => {
    const [summaryData, setSummaryData] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchSummaryData = async () => {
            setLoading(true);

            if (!userId) {
                console.error("Missing userId");
                return;
            }

            try {
                // Access the correct Firestore path: Undepting -> Past -> Data
                const submissionRef = doc(db, `/${userId}/Wealth_Building_Stage/Undepting/Past/data`);
                const submissionDoc = await getDoc(submissionRef);

                if (submissionDoc.exists()) {
                    const data = submissionDoc.data();
                    const totalIncomeMonthly = parseFloat(data.totalIncomeMonthly || 0);

                    let summary = {
                        needs: { ideal: 0, actual: 0 },
                        wants: { ideal: 0, actual: 0 },
                        savings: { ideal: 0, actual: 0 }
                    };

                    // Calculate ideal values based on totalIncomeMonthly (50/30/20 rule)
                    summary.needs.ideal = totalIncomeMonthly * 0.5;
                    summary.wants.ideal = totalIncomeMonthly * 0.3;
                    summary.savings.ideal = totalIncomeMonthly * 0.2;

                    // Assuming actual values are stored in the document
                    if (data.needs) summary.needs.actual = parseFloat(data.needs.actual || 0);
                    if (data.wants) summary.wants.actual = parseFloat(data.wants.actual || 0);
                    if (data.savings) summary.savings.actual = parseFloat(data.savings.actual || 0);

                    setSummaryData(summary);
                } else {
                    console.error('No data found in Past -> Data');
                }
            } catch (error) {
                console.error('Failed to fetch summary data:', error);
            } finally {
                setLoading(false);
            }
        };
        console.log(summaryData);

        fetchSummaryData();
    }, [userId]);


    if (loading) {
        return <div>Loading...</div>;
    }

    if (!summaryData) {
        return <div>No summary available</div>;
    }

    return (
        <div>
            <h1 className="text-4xl text-center font-bold my-4">Financial Plan Summary</h1>
            <table className="w-full border-collapse border">
                <thead>
                    <tr>
                        <th className="border px-4 py-2">Area of Monthly Spending</th>
                        <th className="border px-4 py-2">50/30/20 Rule Max/Min Ideal Monthly</th>
                        <th className="border px-4 py-2">Actual Amount Spent</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="border px-4 py-2">Needs/Necessities</td>
                        <td className="border px-4 py-2">${summaryData.needs.ideal.toFixed(2)}</td>
                        <td className="border px-4 py-2">${summaryData.needs.actual.toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td className="border px-4 py-2">Wants/Luxuries</td>
                        <td className="border px-4 py-2">${summaryData.wants.ideal.toFixed(2)}</td>
                        <td className="border px-4 py-2">${summaryData.wants.actual.toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td className="border px-4 py-2">Savings & Debt Repayment</td>
                        <td className="border px-4 py-2">${summaryData.savings.ideal.toFixed(2)}</td>
                        <td className="border px-4 py-2">${summaryData.savings.actual.toFixed(2)}</td>
                    </tr>
                </tbody>
            </table>

        </div>
    );
};

export default SummaryTable;
